import { render, staticRenderFns } from "./third-vendor-form.vue?vue&type=template&id=4a8861f6&"
import script from "./third-vendor-form.vue?vue&type=script&lang=js&"
export * from "./third-vendor-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports